import React from 'react';
import noop from 'lodash/noop';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import type { AppProps } from './common/types.tsx';
import View from './ui/index.tsx';

function CreateModal(props: AppProps) {
	return (
		<ReportErrors id="unhandled" packageName="jiraCopyFiltersModal" teamName="keystone">
			<AppStyle>
				<View {...props} />
			</AppStyle>
		</ReportErrors>
	);
}

export type { CreateModal };

CreateModal.defaultProps = {
	onCopied: noop,
	onCancel: noop,
};

export default AnalyticsSource('copyFilter', MODAL)(CreateModal);
